<script lang="ts">
	import { PrivacyLayout } from '#lib/websites/privacy/components/PrivacyLayout/index.js';

	interface Props {
		children?: import('svelte').Snippet;
	}

	let { children }: Props = $props();
</script>

<PrivacyLayout>
	{@render children?.()}
</PrivacyLayout>
